import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import { Route } from 'react-router-dom'
import { PROJECT_ID, isProduction } from '../firebaseApp';

const trackingID = (isProduction) ? 'UA-109669902-6' : 'UA-120710905-1';

class GoogleAnalytics extends Component {
    
    componentDidMount() {
        this.logPageChange(
            this.props.location.pathname,
            this.props.location.search
        )
    }

    componentDidUpdate({ location: prevLocation }) {
        const { location: { pathname, search } } = this.props
        const isDifferentPathname = pathname !== prevLocation.pathname
        const isDifferentSearch = search !== prevLocation.search

        if (isDifferentPathname || isDifferentSearch) {
            this.logPageChange(pathname, search)
        }
    }

    logPageChange(pathname, search = '') {
        const page = pathname + search
        const { location } = window
        console.log('GA logging pageview:', page, location);
        ReactGA.set({
            page,
            location: `${location.origin}${page}`,
            ...this.props.options
        })
        ReactGA.pageview(page)
    }

    render() {
        return null
    }
}

GoogleAnalytics.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string
    }).isRequired,
    options: PropTypes.object
}

const RouteTracker = () =>
    <Route component={GoogleAnalytics} />

const init = (options = {}) => {

    ReactGA.initialize(
        trackingID, {
            debug: process.env.REACT_APP_GA_DEBUG === 'true',
            ...options
        }
    )
}

const event = (category,action,label) => {
    ReactGA.event({category,action,label});
}

const modalView = (modalName) => {
    ReactGA.modalview(modalName);
}

const CAAZAM_EVENTS = {
    signUp: 'sign_up',
    signIn: 'login',
    signOut: 'logout',
    profilePhoto: 'profile_photo',
    profileCameraOpen: 'profile_camera_open',
    photoView: 'photo_view',
}

const CATEGORY = {
    user: 'User',
}

export default {
    GoogleAnalytics,
    RouteTracker,
    init,
    event,
    modalView,
    CAAZAM_EVENTS,
    CATEGORY,
}


// WEBPACK FOOTER //
// ./src/Components/GoogleAnalytics.js